(function () {
  if (window.umDiaFormatTabsReady) return;
  window.umDiaFormatTabsReady = true;
  function select(root, key, focus) {
    var tabs = Array.from(root.querySelectorAll('[data-format-tab]'));
    if (!tabs.some(function (tab) { return tab.dataset.formatTab === key; })) return;
    tabs.forEach(function (tab) {
      var active = tab.dataset.formatTab === key;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    root.querySelectorAll('[data-format-panel]').forEach(function (panel) { panel.hidden = panel.dataset.formatPanel !== key; });
  }
  function reveal(target) {
    if (!target) return;
    var panel = target.closest('[data-format-panel]');
    if (panel) select(panel.closest('[data-format-tabs]'), panel.dataset.formatPanel, false);
  }
  function hashTarget(hash) {
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch (error) { return null; }
  }
  function init(scope) {
    scope.querySelectorAll('[data-format-tabs]').forEach(function (root) {
      var tab = root.querySelector('[data-format-tab]');
      var list = root.querySelector('[data-format-tablist]');
      if (!tab || !list) return;
      select(root, root.querySelector('.ud-photo-enquiry[open]') ? 'photos' : tab.dataset.formatTab, false);
      list.hidden = false;
    });
    reveal(hashTarget(window.location.hash));
  }
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-format-tab]');
    if (tab) { select(tab.closest('[data-format-tabs]'), tab.dataset.formatTab, false); return; }
    var link = event.target.closest('[data-photo-prices]');
    if (link) reveal(hashTarget(link.hash));
  });
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-format-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    var root = tab.closest('[data-format-tabs]');
    var tabs = Array.from(root.querySelectorAll('[data-format-tab]'));
    var index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    select(root, tabs[index].dataset.formatTab, true);
  });
  window.addEventListener('hashchange', function () {
    var target = hashTarget(window.location.hash); reveal(target);
    if (target) window.requestAnimationFrame(function () { target.scrollIntoView({block: 'start'}); });
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { reveal(event.target); });
  init(document);
  var initial = hashTarget(window.location.hash);
  if (initial) window.requestAnimationFrame(function () { initial.scrollIntoView({block: 'start'}); });
})();
